import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col w-full gap-30" }

import { PaginatedUserAppointmentsResponse, PersonApi } from '@/apiGenerate/medserver';
import { medServerApiConfig } from '@/config/medserver-api.config';
import { PageableDefaultForUserAppointments } from '@/models/share.model';
import { useAppUserStore } from '@/stores/appUser';
import { useCurrentEntryStore } from '@/stores/currentEntry';
import { toastError } from '@/utils/toast-utils';
import { useToast } from 'primevue';
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import  esAppointmentsContent from '@/views/patientMain/dashbAdmin/appointments/esAppointmentsContent.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'EsAppointments',
  setup(__props) {

const personApi = new PersonApi(medServerApiConfig);

const { t } = useI18n();
const toast = useToast();
const appUser = useAppUserStore();
const currentEntry = useCurrentEntryStore();

const instituteId = computed((): string | undefined => {
    return appUser?.currentHealthGroupMembership?.instituteWithRole?.instituteWithRoleId as string ?? undefined;
});

const patientId = computed(() => {
    return currentEntry?.modalPatient?.personWithRoleId as string ?? undefined;
});

const paginatedUserPastAppointmentsResponse = ref<PaginatedUserAppointmentsResponse>({
    pageable: PageableDefaultForUserAppointments,
    totalRowCount: 0,
    rows: []
});

const paginatedUserComingAppointmentsResponse = ref<PaginatedUserAppointmentsResponse>({
    pageable: PageableDefaultForUserAppointments,
    totalRowCount: 0,
    rows: []
});

const paginatorLoading = ref<boolean>(false);

const findComingAppoinments = (instituteId: string, patientId: string, start: number) => {
    paginatorLoading.value = true;
   
     personApi.findAppointmentsByPerson({ 
        limit: paginatedUserComingAppointmentsResponse.value.pageable.limit,
        start: start,
        instituteId: instituteId,
        personId: patientId, 
        maxDate: new Date().toISOString()
    }).then(pastAppointments => {
        paginatedUserComingAppointmentsResponse.value = pastAppointments;
    }).catch((error) => {
        toastError(toast, {
            summary: t('common.toast.error'),
            detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
        });
    }).finally(() => {
        paginatorLoading.value = false;
    });
};

const findPastAppoinments = (instituteId: string, patientId: string, start: number) => {
    paginatorLoading.value = true;
    personApi.findAppointmentsByPerson({ 
        limit: paginatedUserPastAppointmentsResponse.value.pageable.limit,
        start: start,
        instituteId: instituteId,
        personId: patientId, 
        minDate: new Date().toISOString()
    }).then(pastAppointments => {
        paginatedUserPastAppointmentsResponse.value = pastAppointments;
    }).catch((error) => {
        toastError(toast, {
            summary: t('common.toast.error'),
            detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
        });
    }).finally(() => {
        paginatorLoading.value = false;
    });
};

const reloadComing = (newStart: number) => {
    findComingAppoinments(instituteId.value, patientId.value, newStart);
}

const reloadPast = (newStart: number) => {
    findPastAppoinments(instituteId.value, patientId.value, newStart);
}

onMounted(async () => {
    if (instituteId.value && patientId.value) {
        findComingAppoinments(instituteId.value, patientId.value, paginatedUserComingAppointmentsResponse.value.totalRowCount);
        findPastAppoinments(instituteId.value, patientId.value, paginatedUserPastAppointmentsResponse.value.totalRowCount);
    }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(esAppointmentsContent, {
      title: _unref(t)('patient.appointments.coming'),
      "is-past": false,
      "paginated-user-appointments-response": paginatedUserComingAppointmentsResponse.value,
      onReloadPast: _cache[0] || (_cache[0] = ($event: any) => (reloadPast($event))),
      onReloadComming: _cache[1] || (_cache[1] = ($event: any) => (reloadComing($event)))
    }, null, 8, ["title", "paginated-user-appointments-response"]),
    _createVNode(esAppointmentsContent, {
      title: _unref(t)('patient.appointments.past'),
      "is-past": true,
      "paginated-user-appointments-response": paginatedUserPastAppointmentsResponse.value,
      onReloadPast: _cache[2] || (_cache[2] = ($event: any) => (reloadPast($event))),
      onReloadComming: _cache[3] || (_cache[3] = ($event: any) => (reloadComing($event)))
    }, null, 8, ["title", "paginated-user-appointments-response"])
  ]))
}
}

})